import { FOCUS_TRAP_SELECTOR } from './constants';
const handleClickOutside = ({ event, current, onEscape }, name) => {
    const dialogs = document.querySelectorAll(`${FOCUS_TRAP_SELECTOR}[data-modal-name=${name}]`);
    const isCurrentActiveDialog = dialogs[dialogs.length - 1] === current;
    if (isCurrentActiveDialog &&
        event.target &&
        !dialogs[dialogs.length - 1].contains(event.target)) {
        onEscape();
    }
};
export default handleClickOutside;
//# sourceMappingURL=handleClickOutside.js.map